import browser from 'webextension-polyfill';

export const getExtensionTranslation = (key: string): string => browser.i18n.getMessage((key || '').replace(/ /g, '_'));
export const getExtensionLanguage = (): string => browser.i18n.getUILanguage();
